import { useRef, useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";

const HorizontalScroller = ({ children }) => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft >= 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth <= el.scrollWidth);
  };

  useEffect(() => {
    checkScroll();
    const el = scrollRef.current;
    if (el) {
      el.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
    }
    return () => {
      if (el) el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  const scroll = (direction) => {
    scrollRef.current.scrollBy({
      left: direction === "left" ? -690 : 690,
      behavior: "smooth",
    });
  };

  return (
    <div className="beneficiaryTabsBody">
      {canScrollLeft && (
        <IconButton
          className="scrollArrow left"
          onClick={() => scroll("left")}
          sx={{
            fontSize: "25px",
            fontWeight: "bold",
            color: "rgba(119, 124, 126, 1)",
            backgroundColor: "#f0f0f0",
            "&:hover": {
              backgroundColor: "rgba(63, 196, 244, 1)",
            },
          }}
        >
         <i className="fa fa-chevron-circle-left"></i>
        </IconButton>
      )}
      <div className="beneficiaryTimeline">
        <div className="beneficiaryTabsBodyRow" ref={scrollRef}>
          {children}
        </div>
      </div>
      {canScrollRight && (
        <IconButton
          className="scrollArrow right"
          onClick={() => scroll("right")}
          sx={{
            fontSize: "25px",
            fontWeight: "bold",
            color: "rgba(119, 124, 126, 1)",
            backgroundColor: "#f0f0f0",
            "&:hover": {
              backgroundColor: "rgba(63, 196, 244, 1)",
            },
          }}
        >
          <i className="fa fa-chevron-circle-right"></i>
        </IconButton>
      )}
    </div>
  );
};

export default HorizontalScroller;
